








import { Component, Prop, Vue } from "vue-property-decorator";
import FscModal from "@/components/Modal/FscModal.vue";

@Component({
  components: { FscModal },
})
export default class CheckOverlappingAppointmentsModal extends Vue {
  public name = "CheckOverlappingAppointmentsModal";

  @Prop({ type: String, required: true })
  protected modalId!: string;
}
